export default __webpack_public_path__ + "static/media/receta-de-cocina.2fc0073c.png";